import type { Location, CategoriesMap } from '../types';

/**
 * Get the color for a location based on its fill property or category color
 *
 * Priority:
 * 1. location.fill (explicit color)
 * 2. First category's color
 * 3. null (no color)
 */
export function getColor(location: Location, groups: CategoriesMap): string | null {
  // Direct fill color takes priority
  if (location.fill) {
    return location.fill as string;
  }

  // Check category color
  const firstCategory = location.category[0];
  if (firstCategory && groups[firstCategory]?.color) {
    return groups[firstCategory].color as string;
  }

  return null;
}
